module.exports = __webpack_public_path__ + "img/retomar_chamada.34d692da.gif";